import axios, { AxiosResponse } from 'axios';

import AddPilotLineInput from 'modules/Pilot/models/AddPilotLineInput';

export default function createAsync(apiUrl: string) {
  return function api<TResponse>(
    input: AddPilotLineInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/pilot-lines`,
          method: 'POST',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
